<template>
    <div class="pagesBox">
      <div style="height: 60px; width: 100%"></div>
      <div class="topBtns">
        <el-button
          style="margin-top: 10px"
          class="glo_bgcMainColor"
          @click="submitForm('baseFormRed')"
          >保存</el-button
        >
      </div>
      <div class="formbox">
        <el-form
          :model="baseInForm"
          :rules="rules"
          ref="baseFormRed"
          label-width="130px"
          class="glo_formBox"
        >
          <!-- <el-form-item label="异常编号:" prop="aaa">
            <el-input
              v-model="baseInForm.aaa"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>-->
          <el-form-item label="单据类型:" prop="documentStatus">
            <el-select
              clearable
              v-model="baseInForm.documentStatus"
              placeholder="请选择"
              @change="changeDocStatus"
              disabled
            >
              <el-option
                v-for="item in document_Status_list"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运单号:" prop="documentNumber">
            <!-- <el-input v-model="baseInForm.documentNumber" placeholder="请输入" clearable></el-input> -->
            <el-select
              disabled
              v-model="baseInForm.waybillNumber"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e);
                }
              "
              @focus="
                (e) => {
                  focusMethod();
                }
              "
              @clear="remoteMethod('')"
              @change="
                (e) => {
                  changeMethod(e);
                }
              "
            >
              <el-option
                v-for="(item, index) in wayBillListselect"
                :key="index"
                :label="item.waybillNumber"
                :value="item.waybillNumber"
              />
            </el-select>
          </el-form-item>
  
          <el-form-item label="运单总件数:">
            <el-input
              v-model="baseInForm.totalCount"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="运单总净重:">
            <el-input
              v-model="baseInForm.totalNetWeight"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="委托客户:">
            <el-input
              v-model="baseInForm.customerName"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="收货客户:">
            <el-input
              v-model="baseInForm.receiveCompany"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="提货日期:">
            <el-input
              v-model="baseInForm.takeTime"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="交货日期:">
            <el-input
              v-model="baseInForm.deliveryTime"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="到站:">
            <el-input
              v-model="baseInForm.arrivalArea"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="外发承运商:">
            <el-input
              v-model="baseInForm.outgoingCarrierName"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="承运商货号:">
            <el-input
              v-model="baseInForm.outgoingNumber"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
  
          <el-form-item label="发生时间:" prop="happenTime">
            <el-date-picker
              v-model="baseInForm.happenTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
  
          <el-form-item label="信息来源:">
            <el-select
              v-model="baseInForm.informationSources"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="(item, index) in information_sourcesList"
                :key="index"
                :label="item.key"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
  
          <!-- <el-select v-model="baseInForm.exceptionTypeConfDictId" placeholder="请选择异常类型" clearable @focus="getConfDictValDownList('exception_type')" @change="changeexceptionTypeName">
                <el-option v-for="item in exception_type_list" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
          </el-select>-->
          <el-form-item
            label="异常原因:"
            style="width: 460px"
            prop="billExceptionTypeId"
          >
            <div class="twoInput">
              <el-select
                v-model="baseInForm.billExceptionTypeId"
                @change="changeexception_type_choose_list"
                placeholder="请选择异常类型"
                clearable
              >
                <el-option
                  v-for="item in exception_type_list"
                  :key="item.exceptionTypeId"
                  :label="item.typeName"
                  :value="String(item.exceptionTypeId)"
                ></el-option>
              </el-select>
              <el-select
                v-model="baseInForm.exceptionReasonId"
                @change="changeexception_reason_choose_list"
                clearable
                remote
                placeholder="请选择异常原因"
              >
                <el-option
                  v-for="(item, index) in exception_reason_choose_list"
                  :key="index"
                  :label="item.typeName"
                  :value="String(item.exceptionReasonId)"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="异常范围:">
            <el-select
              v-model="baseInForm.exceptionRange"
              placeholder="请选择"
              clearable
              @change="changeexceptionRange"
            >
              <el-option
                v-for="(item, index) in exception_range_list"
                :key="index"
                :label="item.key"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
  
          <el-form-item label="责任公司/部门:">
            <el-input
              v-model="baseInForm.liabilityCompany"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
  
          <el-form-item label="是否需要赔款:" prop="isIndemnity">
            <el-radio-group v-model="baseInForm.isIndemnity">
              <el-radio :label="1">需要</el-radio>
              <el-radio :label="0">不需要</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="baseInForm.isIndemnity == 1"
            label="收款对象:"
            style="width: 460px"
            prop="objectStatusConfDictId"
          >
            <div class="twoInput">
              <el-select
                v-model="baseInForm.objectStatusConfDictId"
                placeholder="请选择"
                @change="changeObjestStatusYS"
                clearable
              >
                <el-option
                  v-for="(item, index) in objectStatusList"
                  :key="index"
                  :label="item.val"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
              <el-select
                v-model="baseInForm.objectName"
                clearable
                remote
                :allow-create="baseInForm.objectStatusConfDictId == 'other'"
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName1"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            v-if="baseInForm.isIndemnity == 1"
            label="赔付金额:"
            prop="indemnityAmount"
          >
            <el-input
              v-model="baseInForm.indemnityAmount"
              placeholder="请输入"
              clearable
              type="number"
            ></el-input>
          </el-form-item>
          <!--
          <el-form-item label="外发单号:" prop="outgoingNumber">
            <el-input v-model="baseInForm.outgoingNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>-->
          <!-- <el-form-item label="外发单号:" prop="outgoingNumber">
            <el-select v-model="baseInForm.outgoingNumber" placeholder="请选择">
              <el-option
                v-for="(item, index) in CustomerList"
                :key="index"
                label="区域一"
                value="shanghai"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <!-- <el-form-item label="外发承运商:" prop="outgoingCarrierName">
            <el-select v-model="baseInForm.outgoingCarrierName" placeholder="请选择" clearable remote :remote-method="getCarrierList" @change="changeCarrier" @focus="getCarrierList()">
              <el-option v-for="(item, index) in CarrierLists" :key="index" :label="item.carrierName" :value="item.carrierName"></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item
            v-if="baseInForm.isIndemnity == 1"
            label="付款方式:"
            prop="paymentMethodConfDictId"
          >
            <el-select
              v-model="baseInForm.paymentMethodConfDictId"
              placeholder="请选择"
              @focus="getConfDictValDownList('settlement_method')"
            >
              <el-option
                v-for="item in settlement_methodList"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
  
          <el-form-item label="申请部门:" prop="applyDeptId">
            <el-select
              filterable
              clearable
              v-model="baseInForm.applyDeptId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请人:" prop="applyUserId">
            <el-select
              filterable
              clearable
              v-model="baseInForm.applyUserId"
              placeholder="请选择"
              @change="changeUserA"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.documentId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划处理部门:" prop="planHandleDeptId">
            <el-select
              filterable
              clearable
              v-model="baseInForm.planHandleDeptId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="谁跟进:" prop="planHandleUserId">
            <el-select
              filterable
              clearable
              v-model="baseInForm.planHandleUserId"
              @change="changeUser"
              placeholder="请选择"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.documentId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划处理时间:">
            <el-date-picker
              v-model="baseInForm.planHandleTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
  
          <el-form-item label="责任人:">
            <el-input
              v-model="baseInForm.liabilityPerson"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="记录人:">
            <el-input
              v-model="baseInForm.recordPerson"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
  
          <el-form-item
            class="textArea"
            style="width: 100%"
            label="问题描述:"
            prop="describe"
          >
            <el-input
              type="textarea"
              rows="3"
              placeholder="请输入"
              v-model="baseInForm.describe"
            ></el-input>
          </el-form-item>
  
          <el-form-item
            class="textArea"
            style="width: 100%"
            label="原因分析:"
            prop="causeAnalysis"
          >
            <el-input
              type="textarea"
              rows="3"
              placeholder="请输入"
              v-model="baseInForm.causeAnalysis"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="textArea"
            style="width: 100%"
            label="改善措施:"
            prop="handleProposal"
          >
            <el-input
              type="textarea"
              rows="3"
              placeholder="请输入"
              v-model="baseInForm.handleProposal"
            ></el-input>
          </el-form-item>
  
          <el-form-item
            class="textArea"
            style="width: 100%"
            label="完成情况:"
            prop="completeSituation"
          >
            <el-input
              type="textarea"
              rows="3"
              placeholder="请输入"
              v-model="baseInForm.completeSituation"
            ></el-input>
          </el-form-item>
  
          <!-- <el-form-item
            class="textArea"
            style="width: 100%"
            label="异常描述:"
            prop="describe"
          >
            <div id="eidtContent_zh-CN"></div>
          </el-form-item>-->
  
          <div class="uploadBox">
            <div class="uploadItem">
              <div class="uploadLaber">异常图片</div>
              <uploadimgs
                @input="changeFileList"
                :fileNameLists="fileNameLists"
                :limit="9"
              ></uploadimgs>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </template>
  <script>
  import uploadimgs from "@/components/upLoadImgs.vue";
  // import E from "wangeditor";
  export default {
    components: { uploadimgs },
    data() {
      return {
        information_sourcesList: [],
        baseInForm: {
          totalCount: "",
          totalNetWeight: "",
          customerName: "",
          receiveCompany: "",
          takeTime: "",
          deliveryTime: "",
          arrivalArea: "",
          outgoingCarrierName: "",
          outgoingNumber: "",
          informationSources: "",
          liabilityCompany: "",
          liabilityPerson: "",
          recordPerson: "",
          causeAnalysis: "",
          completeSituation: "",
  
          applyDeptId: "",
          applyDeptName: "",
          applyUserId: "",
          applyUserName: "",
          describe: "",
          documentNumber: "",
          documentStatus: "bill_tms_waybill_split_v3:document_status",
          exceptionTypeConfDictId: "",
          exceptionTypeName: "",
          exceptionReasonId: "",
          exceptionReason: "",
          exceptionRange: "",
          fileIds: [],
          handleProposal: "",
          happenTime: "",
          indemnityAmount: 0,
          objectName: "",
          objectNumber: "",
          objectStatusConfDictId: "",
          outgoingCarrierId: "",
          outgoingCarrierName: "",
          outgoingNumber: "",
          paymentMethodConfDictId: "",
          planHandleDeptId: "",
          planHandleDeptName: "",
          planHandleUserId: "",
          planHandleUserName: "",
          planHandleTime: "",
          isIndemnity: 1,
          billExceptionTypeId: "",
        },
        Textcontents: {
          content: "",
          title: "",
          editor: {},
        },
        fileNameLists: [],
  
        rules: {
          documentNumber: [
            { required: true, message: "请输入", trigger: ["blur", "change"] },
          ],
          indemnityAmount: [
            { required: true, message: "请输入", trigger: ["blur", "change"] },
          ],
          documentStatus: [
            { required: true, message: "请选择", trigger: ["blur", "change"] },
          ],
          billExceptionTypeId: [
            { required: true, message: "请选择", trigger: ["blur", "change"] },
          ],
          happenTime: [
            { required: true, message: "请选择", trigger: ["blur", "change"] },
          ],
          objectName: [
            { required: true, message: "请选择", trigger: ["blur", "change"] },
          ],
          objectStatusConfDictId: [
            { required: true, message: "请选择", trigger: ["blur", "change"] },
          ],
          paymentMethodConfDictId: [
            { required: true, message: "请选择", trigger: ["blur", "change"] },
          ],
        },
        CustomerList: [],
        exception_type_list: [], //异常类型
        document_Status_list: [], // 单据类型
        handle_status_list: [], // 处理状态
        objectStatusList: [],
        settlement_methodList: [],
        CustomerListsYF: [],
        CarrierLists: [],
        depList: [],
        employeeList: [],
        wayBillList: [],
        objectStatusType: "",
        exception_reason_choose_list: [],
        exception_range_list: [],
        wayBillListselect: [],
        submitNume: "", //真正提交的单剧编号
        exceptionId: "",
        outboundCarrierName: "",
      };
    },
    watch: {},
    created() {},
    mounted() {
      this.getDepList();
      this.getConfDictValDownList("object_status");
      this.getConfDictValDownList("exception_range");
      this.getConfDictValDownList("settlement_method");
      this.getConfDictValDownList("information_sources");
      this.getObjectUserDownLists("employee");
      this.getStatusValList("bill_tms_waybill_exception_v3.document_status");
      this.getStatusValList("bill_tms_waybill_exception_v3.handle_status");
      this.runPageReportexception_type_choose_list();
      // this.$nextTick(() => {
      //   this.initLangeuage();
      // });
    },
    activated() {
      let exceptionId = this.$route.query.exceptionId || "";
      if (exceptionId) {
        this.exceptionId = exceptionId;
        this.fileNameLists = [];
        this.baseInForm = {
          totalCount: "",
          totalNetWeight: "",
          customerName: "",
          receiveCompany: "",
          takeTime: "",
          deliveryTime: "",
          arrivalArea: "",
          outgoingCarrierName: "",
          outgoingNumber: "",
          informationSources: "",
          liabilityCompany: "",
          liabilityPerson: "",
          recordPerson: "",
          causeAnalysis: "",
          completeSituation: "",
  
          applyDeptId: "",
          applyDeptName: "",
          applyUserId: "",
          applyUserName: "",
          describe: "",
          documentNumber: "",
          documentStatus: "bill_tms_waybill_split_v3:document_status",
          exceptionTypeConfDictId: "",
          exceptionTypeName: "",
          exceptionReasonId: "",
          exceptionReason: "",
          exceptionRange: "",
          fileIds: [],
          handleProposal: "",
          happenTime: "",
          indemnityAmount: 0,
          objectName: "",
          objectNumber: "",
          objectStatusConfDictId: "",
          outgoingCarrierId: "",
          outgoingCarrierName: "",
          outgoingNumber: "",
          paymentMethodConfDictId: "",
          planHandleDeptId: "",
          planHandleDeptName: "",
          planHandleUserId: "",
          planHandleUserName: "",
          planHandleTime: "",
          isIndemnity: 1,
          billExceptionTypeId: "",
        };
        this.getDetails();
      }
    },
    destroyed() {},
    methods: {
      changeexceptionRange() {
        if (this.baseInForm.exceptionRange === "外部") {
          this.baseInForm.liabilityCompany = this.outboundCarrierName;
        }
      },
      getDetails() {
        this.$API
          .wtl_getExceptionDetail({ exceptionId: this.exceptionId })
          .then((res) => {
            let result = res.data.result;
            // planHandleDeptId
            this.baseInForm = result;
            this.baseInForm.exceptionReasonId =
              this.baseInForm.exceptionReasonId + "";
            console.log(" this.baseInForm", this.baseInForm);
            this.exception_reason_choose_list = [
              {
                typeName: this.baseInForm.exceptionReason,
                exceptionReasonId: this.baseInForm.exceptionReasonId + "",
              },
            ];
  
            this.outboundCarrierName = result.outboundCarrierName;
            if (this.baseInForm.billExceptionTypeId) {
              this.changeexception_type_choose_list(result.billExceptionTypeId);
            }
            this.submitNume = result.documentNumber;
            if (res.data.result && res.data.result.fileVos) {
              let arrs = res.data.result.fileVos.map((item) => {
                let objs = {
                  name: item.fileId,
                  url: item.fileUrl,
                };
                return objs;
              });
              this.fileNameLists = arrs;
            }
          });
      },
      //员工、部门、外发网点
      focusMethod() {
        if (this.wayBillListselect.length == 0) {
          this.remoteMethod("");
        }
      },
      // 运单
      remoteMethod(val) {
        this.$API
          .wtl_getWaybillList({
            pageStart: 1,
            pageTotal: 20,
            waybillNumber: val,
          })
          .then((res) => {
            this.wayBillListselect = res.data.result.data || [];
          });
      },
      //员工、部门、外发网点
      changeMethod(e) {
        this.submitNume = "";
        let curs = this.wayBillListselect.filter(
          (item) => item.waybillNumber == e
        );
        this.baseInForm.objectStatusConfDictId = "2";
        if (curs.length) {
          this.submitNume = curs[0].documentNumber;
          this.baseInForm.objectName = curs[0].customerName;
          this.baseInForm.objectNumber = curs[0].customerObjectNumber;
        }
        // if (keys == "intoDeptName") {
        //   this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
        // } else {
        //   this.commandReq[keys] = (curs.length && curs[0].name) || "";
        // }
      },
  
      submitForm(formName) {
        // this.$refs[formName].validate((valid) => {
        //   if (valid) {
        // 富文本内容
        // let describe = this.Textcontents.editor.txt.html();
        let param = JSON.parse(JSON.stringify(this.baseInForm)) || "";
        // param.describe = describe;
        let fids = [];
        let arr =
          (param.fileVos &&
            param.fileVos.length &&
            param.fileVos.map((n) => {
              return n.fileId;
            })) ||
          [];
        // UPDATE ADD  DEL
        fids = this.fileNameLists.map((item) => {
          let imgob = {
            fileId: item.name,
            fileName: item.name,
            operationType: "UPDATE",
          };
          if (arr.length) {
            if (
              arr.findIndex((n) => {
                return n == item.name;
              }) == -1
            ) {
              imgob.operationType = "ADD";
            }
          } else {
            imgob.operationType = "ADD";
          }
          return imgob;
        });
        let arr2 = arr
          .filter((item) => {
            if (
              this.fileNameLists.findIndex((n) => {
                return item == n.name;
              }) == -1
            ) {
              return item;
            }
          })
          .map((item) => {
            return {
              fileId: item,
              fileName: item,
              operationType: "DEL",
            };
          });
        param.fileIds = [...fids, ...arr2];
        param.documentNumber = this.submitNume;
        this.$API.updateException(param).then((res) => {
          this.$message.success(res.data.message || "修改成功");
          this.$TOOLS.closePage();
          this.$router.push({
            path: "/ExceptionManage/ExceptionManage",
            query: {
              isreload: "isreload",
            },
          });
        });
        //   }
        // });
      },
  
      clearPage() {
        this.fileNameLists = [];
        this.baseInForm = {
          totalCount: "",
          totalNetWeight: "",
          customerName: "",
          receiveCompany: "",
          takeTime: "",
          deliveryTime: "",
          arrivalArea: "",
          outgoingCarrierName: "",
          outgoingNumber: "",
          informationSources: "",
          liabilityCompany: "",
          liabilityPerson: "",
          recordPerson: "",
          causeAnalysis: "",
          completeSituation: "",
  
          applyDeptId: "",
          applyDeptName: "",
          applyUserId: "",
          applyUserName: "",
          describe: "",
          documentNumber: "",
          documentStatus: "bill_tms_waybill_split_v3:document_status",
          exceptionTypeConfDictId: "",
          exceptionTypeName: "",
          fileIds: [],
          handleProposal: "",
          happenTime: "",
          indemnityAmount: "",
          objectName: "",
          objectNumber: "",
          objectStatusConfDictId: "",
          outgoingCarrierId: "",
          outgoingCarrierName: "",
          outgoingNumber: "",
          paymentMethodConfDictId: "",
          planHandleDeptId: "",
          planHandleDeptName: "",
          planHandleUserId: "",
          planHandleUserName: "",
          planHandleTime: "",
          isIndemnity: 1,
          billExceptionTypeId: "",
        };
      },
  
      // 选择单据类型
      changeDocStatus(e) {
        console.log("e", e);
        if (e == "bill_tms_waybill_split_v3:document_status") {
          this.getWaybillNumber();
        } else {
          this.wayBillList = [];
          this.baseInForm.documentNumber = "";
        }
      },
  
      // 运单
      getWaybillNumber(val) {
        this.$API
          .wtl_getWaybillList({
            pageStart: 1,
            pageTotal: 50,
            waybillNumber: val,
          })
          .then((res) => {
            this.wayBillList = res.data.result.data || [];
          });
      },
  
      getNumbers(e) {
        if (
          this.baseInForm.documentStatus ==
          "bill_tms_waybill_split_v3:document_status"
        ) {
          this.getWaybillNumber(e);
        }
      },
  
      // 选择运单
      changeWayBill(e) {
        if (e) {
          this.wayBillList.forEach((item) => {
            if (item.waybillNumber === e) {
              console.log(item);
              this.baseInForm.objectName = item.customerName;
              this.objectStatusList.forEach((item) => {
                if (item.key == "customer") {
                  this.baseInForm.objectStatusConfDictId = item.confDictId;
                  this.objectStatusType = "customer";
                  this.getObjectUserDownListYf();
                }
              });
  
              this.getObjectUserDownListYf(item.customerName);
            }
          });
        }
      },
  
      // 选择图片
      changeFileList(array) {
        this.fileNameLists = array;
      },
  
      // 获取业务部门
      getDepList() {
        this.$COMAPI.getDeptList().then((res) => {
          this.depList = res || [];
        });
      },
      // 选择异常类型
      changeexceptionTypeName(e) {
        if (e) {
          this.exception_type_list.forEach((item) => {
            if (item.confDictId == e) {
              this.baseInForm.exceptionTypeName = item.key;
            }
          });
        } else {
          this.baseInForm.exceptionTypeName = "";
        }
      },
      // 选择承运商
      changeCarrier(e) {
        if (e) {
          this.CarrierLists.forEach((item) => {
            if (item.carrierName == e) {
              this.baseInForm.outgoingCarrierId = item.carrierId;
            }
          });
        } else {
          this.getCarrierList();
        }
      },
      // 获取承运商列表
      getCarrierList(carrierName) {
        this.$API
          .CarrierList({
            pageStart: 1,
            pageTotal: 200,
            carrierName: carrierName || "",
          })
          .then((res) => {
            this.CarrierLists = res.data.result.data || [];
          });
      },
      // s申请人
      changeUserA(e) {
        if (e) {
          this.employeeList.forEach((item) => {
            if (item.documentId == e) {
              this.baseInForm.applyUserName = item.name;
            }
          });
        } else {
          this.getCarrierList();
          this.baseInForm.applyUserName = "";
        }
      },
      // 选择计划处理人
      changeUser(e) {
        if (e) {
          this.employeeList.forEach((item) => {
            if (item.documentId == e) {
              this.baseInForm.planHandleUserName = item.name;
            }
          });
        } else {
          this.getCarrierList();
          this.baseInForm.planHandleUserName = "";
        }
      },
  
      getObjectUserDownLists(key) {
        this.$COMAPI.getObjectUserDownList(key).then((res) => {
          if (key == "employee") {
            // 获取员工列表
            this.employeeList = res || [];
          }
        });
        // this.$COMAPI.getObjectUserDownList("employee").then(res=>{}); //获取员工列表
        // this.$COMAPI.getObjectUserDownList("dept").then(res=>{}); //获取部门列表
        // this.$COMAPI.getObjectUserDownList("storage").then(res=>{}); //获取网点列表
      },
      changeexception_type_choose_list(e) {
        this.exception_type_list.forEach((item) => {
          if (item.exceptionTypeId == e) {
            this.baseInForm.exceptionTypeName = item.typeName;
          }
        });
        // this.baseInForm.exceptionReasonId = ''
        this.$API
          .runPageReport({
            conditionReqs: [
              {
                conditonKey: "exceptionTypeId",
                conditonVal: e,
              },
            ],
            number: "exception_reason_choose_list",
            pageStart: 1,
            pageTotal: 200,
          })
          .then((res) => {
            this.exception_reason_choose_list = res.data.result.datas.data || [];
          });
      },
      changeexception_reason_choose_list(e) {
        this.exception_reason_choose_list.forEach((item) => {
          if (item.exceptionReasonId == e) {
            this.baseInForm.exceptionReason = item.typeName;
          }
        });
      },
      async runPageReportexception_type_choose_list() {
        await this.$API
          .runPageReport({
            conditionReqs: [
              {
                conditonKey: "",
                conditonVal: "",
              },
            ],
            number: "exception_type_choose_list",
            pageStart: 1,
            pageTotal: 200,
          })
          .then((res) => {
            this.exception_type_list = res.data.result.datas.data || [];
          });
      },
      // 字典类型
      getConfDictValDownList(key) {
        this.$COMAPI.getConfDictValDownList(key).then((res) => {
          // if (key == "exception_type") {
          //   //异常类型
          //   this.exception_type_list = res || [];
          // }
          if (key == "exception_range") {
            //异常类型
            this.exception_range_list = res || [];
          }
          if (key == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = res;
            this.objectStatusList.forEach((item) => {
              if (item.key == "customer") {
                this.baseInForm.objectStatusConfDictId = item.confDictId;
                this.objectStatusType = "customer";
                this.getObjectUserDownListYf();
              }
            });
          }
          if (key == "settlement_method") {
            // 获取付款方式
            this.settlement_methodList = res;
          }
          if (key == "information_sources") {
            this.information_sourcesList = res;
          }
        });
      },
      // 选择结算对象类型(应收
      changeObjestStatusYS(e) {
        console.log(e);
        this.baseInForm.objectName = "";
        if (e) {
          this.objectStatusList.forEach((item) => {
            if (item.confDictId == e) {
              this.objectStatusType = item.key;
            }
          });
          //
          this.getObjectUserDownListYf();
        } else {
          this.baseInForm.objectName = "";
          this.baseInForm.objectNumber = "";
          this.baseInForm.objectStatusConfDictId = "";
        }
      },
      // (应付弹窗)根据对象类型获取对象的下拉列表
      getObjectUserDownListYf(name) {
        this.$API
          .wtl_getObjectUserDownList({
            key: this.objectStatusType,
            name: name || "",
            pageStart: 1,
            pageTotal: 200,
          })
          .then((res) => {
            this.CustomerListsYF = res.data.result.data || [];
          });
      },
      changeobjectName1(e) {
        if (!e) {
          this.getObjectUserDownListYf();
          this.baseInForm.objectNumber = "";
        } else {
          this.CustomerListsYF.forEach((item) => {
            if (item.name === e) {
              this.baseInForm.objectNumber = item.number;
              // this.baseInForm.objectStatusConfDictId = item.documentId;
            }
          });
        }
      },
      // 状态下拉列表
      getStatusValList(key) {
        this.$TOOLS.getStatusValList(key).then((res) => {
          // 单据类型
          if (key == "bill_tms_waybill_exception_v3.document_status") {
            this.document_Status_list = res || [];
          }
          // 处理状态
          if (key == "bill_tms_waybill_exception_v3.handle_status") {
            this.handle_status_list = res || [];
          }
        });
      },
  
      initLangeuage() {
        this.Textcontents.editor = {};
        this.Textcontents.editor = new E("#eidtContent_zh-CN");
        this.Textcontents.editor.config.height = 200; //富文本高度
        // 编辑器菜单栏配置
        this.Textcontents.editor.config.menus = [
          "head", // 标题
          "bold", // 粗体
          "fontSize", // 字号
          "indent", //缩进
          "fontName", // 字体
          "italic", // 斜体
          "underline", // 下划线
          "strikeThrough", // 删除线
          "foreColor", // 文字颜色
          "backColor", // 背景颜色
          "link", // 插入链接
          "list", // 列表
          "justify", // 对齐方式
          "quote", // 引用
          "emoticon", // 表情
          "table", // 表格
          "code", // 插入代码
          "undo", // 撤销
          "redo", // 重复
        ];
        this.Textcontents.editor.create();
      },
    },
  };
  </script>
  <style scoped lang='less'>
  .topBtns {
    width: calc(100% - 270px);
    position: fixed;
    z-index: 10;
    top: 60px;
    left: 210px;
    background-color: #fff;
    // box-shadow: 2px 2px 5px #ccc;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
  
  .formbox {
    padding: 10px 30px 30px;
  
    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  
    .formBtns {
      height: 30px;
      margin: 0;
      padding: 0 10px;
    }
  
    .checkBoxStyle {
      width: 23%;
      min-width: 260px;
      margin-bottom: 10px;
  
      display: flex;
      align-items: center;
    }
  }
  
  .uploadBox {
    width: 100%;
    display: flex;
    align-items: center;
  
    .uploadItem {
      flex: 1;
  
      .uploadLaber {
        margin-bottom: 10px;
      }
    }
  }
  
  .topBtns {
    margin: 0 30px;
    height: 50px;
  }
  
  .twoInput {
    display: flex;
  }
  
  .textArea {
    height: auto !important;
    /deep/.el-textarea__inner {
      color: #000 !important;
      font-weight: bold;
      font-size: 18px;
    }
  }
  .glo_formBox .textArea {
    /deep/ .el-form-item__content {
      height: auto !important;
      z-index: 0;
    }
  }
  </style>